module.exports = __webpack_public_path__ + "img/Accountor-33-lowres.d142e869.jpg";